var map = {
	"./template.bet777": 1949,
	"./template.bet777.tsx": 1949,
	"./template.betgalaxy": 1950,
	"./template.betgalaxy.tsx": 1950,
	"./template.betprofessor": 1951,
	"./template.betprofessor.tsx": 1951,
	"./template.chromabet": 1952,
	"./template.chromabet.tsx": 1952,
	"./template.default": 340,
	"./template.default.tsx": 340,
	"./template.gigabet": 2131,
	"./template.gigabet.tsx": 2131,
	"./template.pyramidbet": 2018,
	"./template.pyramidbet.tsx": 2018,
	"./template.slambet": 1953,
	"./template.slambet.tsx": 1953,
	"./template.ts": 1002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2796;